function state() {
  return {
    selectedInsurer: { code: "ALL" },

    fetchParameter: {},
    paymentToInsurerRequest: {},
    paymentToInsurerRequestList: [],
    paymentToInsurerRequestMeta: {},

    insurerBranchList: [],
  };
}

export default state;
